/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [],
        name: "AmountMustBeGreaterThanZero",
        type: "error",
    },
    {
        inputs: [],
        name: "CantRenounceOwnerRole",
        type: "error",
    },
    {
        inputs: [],
        name: "ContractAlreadySet",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToGetAssetDecimals",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransfer",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "interestAccrued",
                type: "uint256",
            },
        ],
        name: "InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "InvalidContractAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrancyGuardReentrantCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
        ],
        name: "UnauthorizedBeneficiary",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Donate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "InterestWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "representationToken",
                type: "address",
            },
        ],
        name: "RepresentationTokenSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amountMinted",
                type: "uint256",
            },
        ],
        name: "Supply",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "XUnityTrinityEulerPoolInitialized",
        type: "event",
    },
    {
        inputs: [],
        name: "ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BENEFICIARY_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "donate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getAvailableInterest",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMembers",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_unity",
                type: "address",
            },
            {
                internalType: "address",
                name: "_eulerPool",
                type: "address",
            },
            {
                internalType: "address",
                name: "_yieldToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "representationToken",
        outputs: [
            {
                internalType: "contract IERC20Mintable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_representationToken",
                type: "address",
            },
        ],
        name: "setRepresentationToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "supply",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unityToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
        ],
        name: "withdrawAvailableInterest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "yieldToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class XUnityTrinityEuler__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
XUnityTrinityEuler__factory.bytecode = _bytecode;
XUnityTrinityEuler__factory.abi = _abi;
//# sourceMappingURL=XUnityTrinityEuler__factory.js.map